import { createGlobalStyle } from "styled-components";
import { tokens } from "../../../public/tokens";

/**
 * Scoped via Swal's own `customClass.popup: "ami-confirm-dialog"` (see `confirmDialog.js`), since
 * SweetAlert2 renders its popup outside the React tree and can't be styled by wrapping it in JSX.
 */
export const ConfirmDialogGlobalStyle = createGlobalStyle({
    ".ami-confirm-dialog .swal2-confirm": {
        backgroundColor: tokens.colors.brand["aie-blue"]["500"],
    },
    ".ami-confirm-dialog .swal2-cancel": {
        backgroundColor: tokens.colors.states.alert["500"],
    },
});
